import { Component } from '@angular/core';
import { MppService } from '@app/mpp/service/mpp.service';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { RecipeDetailService } from '../services/recipe-detail.service';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from '@ionic/angular';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { RecipeDetailPage } from '../recipe-detail.page';
import { MppProductCardService } from '@app/mpp/shared/services/mpp-product-card/mpp-product-card.service';

@Component({
  selector: 'app-ingredients-mobile',
  templateUrl: './ingredients-mobile.page.html',
  styleUrls: [
    './ingredients-mobile.page.scss',
    '../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientsMobilePage extends RecipeDetailPage {
  constructor(
    public mppService: MppService,
    readonly platformService: PlatformService,
    readonly panAppState: PanAppState,
    readonly translateService: TranslateService,
    public recipeDetailService: RecipeDetailService,
    readonly popoverController: PopoverController,
    readonly mppProductCardService: MppProductCardService,
  ) {
    super(
      mppService,
      platformService,
      panAppState,
      translateService,
      recipeDetailService,
      popoverController,
      mppProductCardService,
    );
    this.viewModel$ = this.recipeDetailService.recipeViewModel$;
  }
  ionViewWillEnter(): void {
    this.setupTitle();
    this.recipeDetailService.updateShowHidePortion(false);
  }

  setupTitle() {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.mppIngredients),
    );
  }

  ionViewWillLeave(): void {}

  handleCostInfoIconClickEvent($event) {
    this.recipeDetailService.showCostInfoPopover($event);
  }
}
